<template>
	<div class="tw-flex tw-flex-col tw--mx-10">
		<p-card class="tw-w-full tw-flex">
			<p-button
				type="secondary"
				@click="addNewTemplate">Agregar Plantilla</p-button>
		</p-card>
		<app-table
			class="mt-3 no-main-list"
			:filter-columns="false"
			:main-list="true"
			:rows="templates"
			:columns="columns">
			<template slot="rows" slot-scope="props">
				<td style="text-align: left; width: 70%; padding-left: 40px;" v-show="showRow(columns, 1)">{{ props.row.name }}</td>
				<td v-show="showRow(columns, 2)">
					<template>
						<app-tooltip-button
							:img="`${$imageUrl}/edit.svg`"
							text="Editar"
							@click-icon="editTemplate(props.row)"
						/>
						<app-tooltip-button
							:img="`${$imageUrl}/delete-button.svg`"
							text="Eliminar"
							@click-icon="deleteTemplate(props.row)"
						/>
					</template>
				</td>
			</template>
			</app-table>
			<p-confirm-dialog ref="confirmDelete"></p-confirm-dialog>
	</div>
</template>

<script>
	import PCard from '@/modules/shared/components/ui/Card/p-card';
	import PButton from '@/modules/shared/components/ui/p-button';
	import PConfirmDialog from '@/modules/shared/components/ui/p-confirm-dialog';

	export default {
		name: 'list-messaging-templates',
		data() {
			return {
				columns: [
					{
						id: 1,
						name: 'Nombre',
						value: 'name',
						visible: true,
						checked: true,
					},
					{
						id: 2,
						name: 'Acciones',
						visible: true,
					},
				],
				templates: [],
			};
		},
		created() {
			this.loadData();
		},
		components: { PCard, PButton, PConfirmDialog },
		methods: {
			async loadData() {
				try {
					const { data: response } = await this.$httpPraktiko.get('/template-formats');
					this.templates = response;
				} catch (error) {
					this.showgenericError();
				}
			},
			addNewTemplate() {
				this.goTo('new');
			},
			editTemplate(row) {
				const params = row;
				this.goTo('new', { params });
			},
			deleteTemplate(row) {
				this.$refs.confirmDelete.showConfirm({
					onOk: async () => {
						try {
							await this.$httpPraktiko.delete(`/template-formats/${row.id}`);
							this.showNotification('Plantilla Eliminada Exitosamente');
							this.loadData();
						} catch (error) {
							this.showGenericError();
						}
					},
					title: `¿Seguro que desea eliminar "${row.name}" de la lista?.`,
				});
			},
		},
		computed: {
		},
	};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/configuration/messaging-templates/list-messaging-templates.vue